<template>
  <div class="btn-close" v-on:click="close">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 14 14"
      fill="#FFF"
    >
      <path
        d="M7.516 6l4.17-4.17A1.072 1.072 0 0 0 10.17.313L6 4.484 1.83.314A1.072 1.072 0 0 0 .314 1.829L4.484 6l-4.17 4.17a1.072 1.072 0 1 0 1.516 1.516L6 7.516l4.17 4.17a1.068 1.068 0 0 0 1.516 0 1.072 1.072 0 0 0 0-1.516z"
      />
    </svg>
  </div>
</template>

<script>
// import des différentes mutations
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      closeEvent: new Event("reco_app:close")
    };
  },
  computed: {
    ...mapState([
      "current_page",
      "current_question",
      "history",
      "age",
      "genre",
      "freqLecture",
      "typeLecture",
      "oneShot",
      "suprise",
      "offSet",
      "range",
      "changeGenre"
    ])
  },
  methods: {
    ...mapMutations([
      "SET_CURRENTPAGE",
      "SET_CURRENTQUESTION",
      "SET_RESETHISTORY",
      "SET_AGE",
      "SET_GENRE",
      "SET_FREQLECTURE",
      "SET_TYPELECTURE",
      "SET_ONESHOT",
      "SET_SURPRISE",
      "SET_OFFSET",
      "RESET_OFFSET",
      "SET_RANGE"
    ]),
    close() {
      // reset des valeurs
      this.SET_CURRENTPAGE("accueil");
      this.SET_CURRENTQUESTION(0);
      this.SET_RESETHISTORY();
      this.SET_AGE(null);
      this.SET_GENRE(null);
      this.SET_FREQLECTURE(null);
      this.SET_TYPELECTURE(null);
      this.SET_ONESHOT(null);
      this.SET_SURPRISE(null);
      this.RESET_OFFSET();
      this.SET_RANGE(3);

      const { closeEvent } = this;
      window.dispatchEvent(closeEvent);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-close {
  position: absolute;
  z-index: 5;
  right: 20px;
  top: 28px;
  width: 24px;
  height: 24px;
  color: white;
  cursor: pointer;
}
</style>
